/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

//The code below hides the images that are not from the selected variant (image group), and shows the ones that are part of it
//Written to work with the custom image gallery only
(function(){
  if( !document.querySelector('.HorizontalList__Item') ) return;
  var variantRadios = document.querySelectorAll('.ColorSwatch__Radio');

  //convert all templates to div so we can select elements again
  function templateToDiv(){
    var templates = document.querySelectorAll('.Product_Gallery--6S template.Product_Gallery__Item')
    templates.forEach(function(template) {
      templateDivMagic(template)
    })
  }
  
  function templateDivMagic(targetElement){
    var newElement = document.createElement('template');
    
    if(targetElement.tagName.toLowerCase() == "template"){
      newElement = document.createElement('div');
    }            

    // Copy the element's attributes to the new element
    for (let i = 0; i < targetElement.attributes.length; i++) {
      const {name, value} = targetElement.attributes[i];
      newElement.setAttribute(name, value);
    }
    
    // Set the content of the new element to the content of the div element
    newElement.innerHTML = targetElement.innerHTML;
    
    // Replace the div element with the new element
    targetElement.parentNode.replaceChild(newElement, targetElement);
  }   

  variantRadios.forEach(function(radio) {
    radio.addEventListener('change', function() {
      templateToDiv();

      var variantImages = document.querySelectorAll('.Product_Gallery--6S img');            
      var selectedVariantGroup = this.dataset.group;
  
      variantImages.forEach(function(image) {
        //we can't just hide the images that do not belong to the group because they are stil accounted in the CSS grid-template, and we can't make it work with nth-of-type if we just hide them
        //instead of removing elements and putting them back, we simply transform them into a template tag that gets ignored if they are not part of the group, then make them a div if they are part, to be displayed
        if(image.dataset.group){
          if (image.dataset.group === selectedVariantGroup) {
            image.closest('.Product_Gallery__Item').parentElement.tagName == "template" && templateDivMagic(image.closest('.Product_Gallery__Item'))
          } else {
            templateDivMagic(image.closest('.Product_Gallery__Item'))            
          }
        }
      });
    });
  });

  /* This piece of cod crosses out size/letter variants when another variant is selected, such as colour */
  const variantNonSizeInputs = document.querySelectorAll('.ProductForm__Variants input:not([class*="SizeSwatch"])')
  const variantSizeInputs = document.querySelectorAll('.ProductForm__Variants input[class*="SizeSwatch"]')
  const jsonData = document.querySelector('[data-product-json]')?JSON.parse(document.querySelector('[data-product-json]').innerHTML):"";
  const productData = jsonData['product'];

  if(!jsonData) return;
  if(!variantNonSizeInputs || variantNonSizeInputs.length < 1 ) return;
  
  function _updateSizeVariants(){
    if(!variantSizeInputs || !variantNonSizeInputs) return

    variantNonSizeInputs.forEach( variantNonSizeInput => {
      variantNonSizeInput.addEventListener('change', () => {
        const nonSizeValue = variantNonSizeInput.value
        variantSizeInputs.forEach( variantSizeInput => {
          const variantSizeLabel = variantSizeInput.parentElement.querySelector('label')
          variantSizeLabel.classList.remove('SizeSwatch--OOS')
          const sizeValue = variantSizeInput.value
          productData['variants'].forEach(function (variant) {
            //console.log(nonSizeValue, sizeValue, variant.options, variant.available)
            if(variant.options.includes(sizeValue) && variant.options.includes(nonSizeValue)){
              if (!variant.available) variantSizeLabel.classList.add('SizeSwatch--OOS')
            }
          })
        })        
      })
    })
  }
  _updateSizeVariants()
  //Make sure to dispatch the event because it seems like it doesn't
  variantNonSizeInputs[0].dispatchEvent(new Event('change'))

})()


function addBundleMessage(){
  const slidecart = document.getElementById('slidecarthq')
  if(!slidecart) return;

  const cartItems = slidecart.querySelector('.items')
  cartItems.querySelectorAll('.item').forEach( cartItem => {
    const cartItemTitle = cartItem.querySelector('h3.title')
    const cartProperties = cartItem.querySelector('.properties-key-value')
    //product URL
    const productURL = cartItemTitle.querySelector('a')?.href.replace('?','.json?');

    fetch(productURL)
    .then( r => r.json() )
    .then( resp => {
      if(!resp.product) return;
  
      const productTags = resp.product.tags.split(",")
      const containsBundleTag = productTags.some(tag => tag.toLowerCase().includes("bundle"));

      if(!cartItemTitle.classList.contains("has-bundle-message") && containsBundleTag){
        cartItemTitle.classList.add('has-bundle-message')
        cartProperties.insertAdjacentHTML('afterend', '<span class="bundle-message">ORDER 3+ ITEMS & SAVE 20%</span>')
      }
    })
  })
} 

(function(){
  
  function addComparePricesToSC({ items }) {
    //console.log('addComparePricesToSC()') 
    items.forEach(async (item) => {
      try {
        let currentItemId = item.variant_id;  
        let response = await fetch(`/products/${item.handle}.js`); 
        let allInformation = await response.json();
  
        let { variants } = allInformation;  
        //console.log('variants', variants)
  
        variants.forEach( (variant) => {
          if(variant.id == currentItemId){
            const price = variant.price
            const compare_at_price = variant.compare_at_price
            //console.log('price',price,'compare_at_price',compare_at_price)
            
            if (price > 0 && compare_at_price > 0 && price < compare_at_price) {
              let priceBlock = `<span class='price-compare-at'>${theme.moneyFormat.replace("{{amount_with_comma_separator}}",(compare_at_price / 100)).replace("{{amount}}",(compare_at_price / 100))}</span>
                                <span class='price'><span class='money'>${theme.moneyFormat.replace("{{amount_with_comma_separator}}",(price/100)).replace("{{amount}}",(price/100))}</span></span>`;
              let element = document.querySelector(`.slidecarthq .item[data-variant-id='${currentItemId}']`)
              if(!element) return
              let priceDiscountBlock = element.querySelector('.price-discount-block');
              if(priceDiscountBlock) priceDiscountBlock.innerHTML = priceBlock;
            }
          }
        })
      } catch (e) {
        console.log(e);
      }
    });
  }  
  
  let slidecartCurrency = Shopify.currency?.active?.toLowerCase();
  let slidecartCountry = Shopify.country?.toLowerCase();
  const freeShipExclusions = []; //['au', 'ca', 'nz', 'us', 'sg', 'ae'];
  
  function slidecartSetReward() {
    try {
      if (slidecartCountry == "gb") {
        window.SLIDECART_STATE().settings.rewards_tiers[0].amount = "100";
      } else if (freeShipExclusions.includes(slidecartCountry)) {
        window.SLIDECART_STATE().settings.rewards = false;
      } else {
        window.SLIDECART_STATE().settings.rewards_tiers[0].amount = "150";
      }
    } catch (err) {
      console.log(err);
    }
  }

  function slidecartSetRewardCurrency() {
    try {
      if (slidecartCurrency == "gbp") {
        window.SLIDECART_STATE().settings.rewards_tiers[0].amount = "100"; // Update this number to modify the GBP threshold
      } else if (slidecartCurrency == "eur") {
        window.SLIDECART_STATE().settings.rewards_tiers[0].amount = "150"; // Update this number to modify the EUR threshold
      } else if (slidecartCurrency == "usd") {
        window.SLIDECART_STATE().settings.rewards_tiers[0].amount = "150"; // Update this number to modify the USD threshold
      } else if (freeShipExclusions.includes(slidecartCountry)) {
        window.SLIDECART_STATE().settings.rewards = false;
      } else {
        window.SLIDECART_STATE().settings.rewards_tiers[0].amount = "150";
      }
    } catch (err) {
      console.log(err);
    }
  }
  
  function addDiscountLabelObserver(){
    const slidecart = document.getElementById('slidecarthq')
    //console.log('slidecart',slidecart)
    if(!slidecart) return;
  
    const config = {
        attribute: false,
        childList: true,
        subtree: true };

    const slidecartObserverCallback = (mutationsList, observer) => {
      for (var mutation of mutationsList) {
        const upsellsContainer = slidecart.querySelector('.upsells');
        if (!upsellsContainer) return;
        
        const upsellItems = upsellsContainer.querySelector('.upsells-stacked');
        //console.log('upsellItems',upsellItems)
        if (!upsellItems) return;           

        //console.log('mutation.target.classList',mutation.target.classList)
        if (mutation.target.classList.contains('upsells-stacked')) {
          console.log('Content added to the slidecart.', slidecart);
          
          // Check added nodes for the 'upsells-stacked' class
          let hasUpsellsStacked = false;
          mutation.addedNodes.forEach(node => {
              if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('upsell')) {
                  hasUpsellsStacked = true;
                  //console.log('Added node with class "upsell-item":', node);
              }
          });       
          if(hasUpsellsStacked){

            //add sale labels to items
            upsellItems.querySelectorAll('.upsell-item').forEach( upsellItem => {
              const comparePrice = upsellItem.querySelector('.upsell-compare-at .money')?.innerHTML.replace("£","")
              let finalPrice = upsellItem.querySelector('.upsell-latest-price .money')?.innerHTML.replace("£","")
              if(!finalPrice) finalPrice = upsellItem.querySelector('p:not(.upsell-latest-price):not(.upsell-compare-at) .money')?.innerHTML.replace("£","")
              const itemImage = upsellItem.querySelector('.upsell-image')
              //console.log('comparePrice',comparePrice, 'finalPrice', finalPrice, 'itemImage', itemImage)
          
              if(parseFloat(comparePrice) > 0 && parseFloat(finalPrice) > 0 && parseFloat(comparePrice) > parseFloat(finalPrice)){
                let discountPercentage = Math.round((parseFloat(comparePrice) - parseFloat(finalPrice)) * 100 / parseFloat(comparePrice));
                let discountLabel = '<span class="ProductItem__Label ProductItem__Label--onSale Heading Text--subdued">'+discountPercentage+'% OFF</span>'
                if(itemImage && !itemImage.classList.contains('upselll-labeled')) {
                  itemImage.innerHTML = itemImage.innerHTML + discountLabel
                  itemImage.classList.add('upselll-labeled')
                }
              }
            })

            attachListenersToUpsellAddToCartButtons();//Klaviyo ATC tracking
  
            //add buttons to slider
            if(upsellItems.querySelectorAll('.upsell-item').length > 2 && upsellsContainer.querySelectorAll('.flickity-prev-next-button').length == 0){
              const upsellsContainer = slidecart.querySelector('.upsells');

              // Create previous button
              const prevButton = document.createElement('button');
              prevButton.className = 'flickity-prev-next-button previous';
              prevButton.type = 'button';
              prevButton.setAttribute('aria-label', 'previous');
              
              const prevSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
              prevSvg.setAttribute('viewBox', '0 0 100 100');
              
              const prevPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
              prevPath.setAttribute('d', 'M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z');
              prevPath.className = 'arrow';
              
              prevSvg.appendChild(prevPath);
              prevButton.appendChild(prevSvg);
              
              // Create next button
              const nextButton = document.createElement('button');
              nextButton.className = 'flickity-prev-next-button next';
              nextButton.type = 'button';
              nextButton.setAttribute('aria-label', 'next');
              
              const nextSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
              nextSvg.setAttribute('viewBox', '0 0 100 100');
              
              const nextPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
              nextPath.setAttribute('d', 'M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z');
              nextPath.className = 'arrow';
              //nextPath.setAttribute('transform', 'translate(100, 100) rotate(180)');
              
              nextSvg.appendChild(nextPath);
              nextButton.appendChild(nextSvg);
              
              // Append buttons to the container
              upsellsContainer.appendChild(prevButton);
              upsellsContainer.appendChild(nextButton);
                
              const styleElement = document.createElement('style');              
              styleElement.innerHTML = `
                #slidecarthq .upsells-stacked:before { display: none !important; }
                #slidecarthq .upsells-stacked:after { display: none !important;; }
              `;              
              // Append the style element to the document head
              document.head.appendChild(styleElement);
            }
            
            //add functionality to pseudo elements arrows
            
            const upsellsStacked = document.querySelector('.upsells-stacked');    
            function updateArrows() {
              if (upsellsStacked.scrollLeft === 0) {
                upsellsStacked.classList.add('slider-arrow-hidden-left');
              } else {
                upsellsStacked.classList.remove('slider-arrow-hidden-left');
              }
          
              if (upsellsStacked.scrollLeft + upsellsStacked.clientWidth >= upsellsStacked.scrollWidth) {
                upsellsStacked.classList.add('slider-arrow-hidden-right');
              } else {
                upsellsStacked.classList.remove('slider-arrow-hidden-right');
              }
            }    
            function scrollLeft() {
              upsellsStacked.scrollBy({ left: -upsellsStacked.clientWidth, behavior: 'smooth' });
            }    
            function scrollRight() {
              upsellsStacked.scrollBy({ left: upsellsStacked.clientWidth, behavior: 'smooth' });
            }    

            function handleClick(event) {
              const rect = upsellsStacked.getBoundingClientRect();
              if (event.clientX < rect.left + 30) {
                  scrollLeft();
              } else if (event.clientX > rect.right - 30) {
                  scrollRight();
              }
            }
            
            upsellsStacked.addEventListener('scroll', updateArrows);
            //upsellsStacked.addEventListener('click', handleClick);
            
            
            const prevButtonElem = upsellsContainer.querySelector('.flickity-prev-next-button.previous')
            const nextButtonElem = upsellsContainer.querySelector('.flickity-prev-next-button.next')
            if(prevButtonElem && nextButtonElem){
              prevButtonElem.addEventListener('click', handleClick);
              nextButtonElem.addEventListener('click', handleClick);
            }
          
            // Initial check
            updateArrows();

            // Equalize height of .upsell-text > p
            const equalizeUpsellTextHeights = () => {
              const titleEls = upsellItems.querySelectorAll('.upsell-text > p');
              let maxHeight = 0;
            
              // Reset heights to auto first
              titleEls.forEach(el => el.style.height = 'auto');
            
              // Get max height
              titleEls.forEach(el => {
                const height = el.offsetHeight;
                if (height > maxHeight) maxHeight = height;
              });
            
              // Set all to max height
              titleEls.forEach(el => el.style.height = `${maxHeight}px`);
            };
            
            equalizeUpsellTextHeights();

            
          };
        }
      }
    }
    
    // Create an observer instance linked to the callback function for slidecart
    const slidecartObserver = new MutationObserver(slidecartObserverCallback);
  
    // Start observing the slidecart for configured mutations
    slidecartObserver.observe(slidecart, config);
  }

  function addDiscountLabel(){
    const slidecart = document.getElementById('slidecarthq')
    //console.log('slidecart',slidecart)
    if(!slidecart) return;
      
    const upsellItems = slidecart.querySelector('.upsells-stacked');
    if (!upsellItems) return;
  
    upsellItems.querySelectorAll('.upsell-item').forEach( upsellItem => {
      //console.log('upsellItems',upsellItems)
      const comparePrice = upsellItem.querySelector('.upsell-compare-at .money')?.innerHTML.replace("£","")
      let finalPrice = upsellItem.querySelector('.upsell-latest-price .money')?.innerHTML.replace("£","")
      if(!finalPrice) finalPrice = upsellItem.querySelector('p:not(.upsell-latest-price):not(.upsell-compare-at) .money')?.innerHTML.replace("£","")
      const itemImage = upsellItem.querySelector('.upsell-image')
      //console.log('comparePrice',comparePrice, 'finalPrice', finalPrice, 'itemImage', itemImage)
  
      if(parseFloat(comparePrice) > 0 && parseFloat(finalPrice) > 0 && parseFloat(comparePrice) > parseFloat(finalPrice)){
        let discountPercentage = Math.round((parseFloat(comparePrice) - parseFloat(finalPrice)) * 100 / parseFloat(comparePrice));
        let discountLabel = '<span class="ProductItem__Label ProductItem__Label--onSale Heading Text--subdued">'+discountPercentage+'% OFF</span>'
        if(itemImage && !itemImage.classList.contains('upsell-labeled')) {
          itemImage.innerHTML = itemImage.innerHTML + discountLabel
          itemImage.classList.add('upsell-labeled')
        }
      }
    })
  }

  function correctAmpFooterCode(){
    const slidecart = document.getElementById('slidecarthq')
    if(!slidecart) return;
    const footerCode = slidecart.querySelector('.footer-code')
    if(!footerCode) return;
    
    let footerCodeText = footerCode.innerHTML
    if(!footerCodeText) return
    footerCodeText = footerCodeText.replace(/&amp;/g, '&');
    footerCode.innerHTML = footerCodeText
  }

   // Attach Klaviyo custom ATC tracking to Upsell ATC buttons 
    function attachListenersToUpsellAddToCartButtons() {
      var _learnq = window._learnq || [];
      const slidecart = document.getElementById('slidecarthq')
      var upsells = slidecart.querySelectorAll('.upsells-stacked .upsell')
      if(!upsells) return;

      const upsellsOptionsOverlays = slidecart.querySelectorAll('.upsell-options-overlay')
      
      upsells.forEach( upsell => {
        const productId = upsell.dataset.slidecartProductId
        const productImage = upsell.querySelector('.upsell-image a img')?.src
        const productTitle = upsell.querySelector('.upsell-text h3 a')?.innerHTML
        const productURL = upsell.querySelector('.upsell-text h3 a')?.href
        const productPrice = upsell.querySelector('.upsell-text-prices p .money')?.innerHTML
        const upsellOptionOverlay = slidecart.querySelector('.upsell-options-overlay[data-slidecart-product-id="'+productId+'"]')
        var atcButton = upsell.querySelector('.upsell-add button')
        if(upsellOptionOverlay){
          atcButton = upsellOptionOverlay.nextElementSibling?.querySelector('button.button')
        }
        if(atcButton){
          var klAjax = true;
          atcButton.addEventListener("click", function() {
            if (klAjax && !atcButton.dataset.listening) {
              let  item = {
                  Name: productTitle,
                  ProductID: productId,
                  //Categories: ["2024 SPRING COLOURS", "ALL PRODUCTS", "BEST OF SUMMER SALE", "Bridesmaid Dresses", "BRIDESMAID DRESSES UNDER £100", "CHIFFON BRIDESMAID DRESSES", "NEUTRAL BRIDESMAID DRESSES", "PRE ORDER - CHIFFON (Do Not Delete)", "SMARTSIZE - BRIDESMAID DRESSES - CHIFFON BOW TIE SHOULDER", "SUMMER SALE", "SUMMER SALE BRIDESMAID DRESSES"],
                  ImageURL: productImage,
                  URL: productURL,
                  Brand: "Six Stories",
                  Price: productPrice,
                  CompareAtPrice: ""
              };

              //console.log("ITEM TRACKED: ", item)
            
              _learnq.push(['track', 'Added to Cart', item]);
              atcButton.setAttribute('data-listening','true')
              klAjax = false;
            }
          });
        }
      })

    }

  window.SLIDECART_LOADED = (cart) => {
    //console.log('CART LOADED')
    //if (slidecartCountry) slidecartSetReward();
    fetch('https://get.geojs.io/v1/ip/geo.json')
        .then((res)=>res.json())
        .then(res =>{
          SLIDECART_STATE().settings.announcements = false; 
          const location = res.country_code;
          console.log("Location: ", location);
          if (location == "US") {
            SLIDECART_STATE().settings.announcements = true; 
          }
        });
    if (slidecartCurrency) slidecartSetRewardCurrency();
    addDiscountLabelObserver();
    correctAmpFooterCode();
  }
  
  window.SLIDECART_UPDATED = (cart) => {
    //console.log('CART UPDATED')
    //if (slidecartCountry) slidecartSetReward();
    if (slidecartCurrency) slidecartSetRewardCurrency();
    addComparePricesToSC(cart)
    addDiscountLabelObserver()
    correctAmpFooterCode()
    
  }
  window.SLIDECART_OPENED = (cart) => {
    //console.log('CART OPENED')
    addComparePricesToSC(cart)
    addDiscountLabelObserver()
    correctAmpFooterCode()
    
  }
})();

/*
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    //console.log(CozyCountryRedirect, CozyCountryRedirect.country, "XXXX")
    if(CozyCountryRedirect && CozyCountryRedirect.country && CozyCountryRedirect.country.toLowerCase() == "xxx"){
      console.log(CozyCountryRedirect, CozyCountryRedirect.country, "XXXX")
      let bundleFreeShippingMessage = document.querySelector('.rbr-totalBox__freeShipping_con')
      if(bundleFreeShippingMessage) bundleFreeShippingMessage.style.display = 'block'
    }
  }, 5000)
})
*/

/* Resize variant size boxes to match the widest one */
document.addEventListener("DOMContentLoaded", () => {
  const list = document.querySelector(".SizeSwatchList");
  const lis = list?.querySelectorAll("li");

  if (!list || !lis) return;

  let maxWidth = 0;
  lis.forEach(li => {
    const label = li.querySelector("label");
    const labelWidth = label.offsetWidth;
    if (labelWidth > maxWidth) maxWidth = labelWidth;
  });

  lis.forEach(li => {
    const label = li.querySelector("label");
    label.style.width = `${maxWidth}px`;
    label.style.height = `${maxWidth}px`;
  });
});

function triggerNotAvailablePopup(){
  const notAvailableLink = document.getElementById('link--variant-not-available')
  //console.log('notAvailableLink', notAvailableLink)
  if(notAvailableLink){
    notAvailableLink.addEventListener('click', (e) => {
      e.preventDefault()
      const klaviyoNotifyMeButton = document.querySelector('.klaviyo-bis-trigger')
      if(klaviyoNotifyMeButton) klaviyoNotifyMeButton.click()
      return false;
    })
    notAvailableLink.style.display = 'inline-block'
  }
}

document.addEventListener("DOMContentLoaded", function() {
  triggerNotAvailablePopup()

  // Select all outer Flickity slider elements
  const outerSliders = document.querySelectorAll('.ProductList.ProductList--carousel');
  
  if (outerSliders.length > 0) {
      // Iterate over each outer slider
      outerSliders.forEach(outerSliderElement => {
          var outerFlickity = Flickity.data(outerSliderElement);
  
          // Make sure outer Flickity instance exists
          if (outerFlickity) {
              // Select all inner carousels within this outer slider
              const carousels = outerSliderElement.querySelectorAll('.ProductItem__ImageCarousel');
  
              // If inner carousels exist, apply the logic
              if (carousels.length > 0) {
                  carousels.forEach(carousel => {
                      // Disable dragging on the outer slider when interacting with the inner carousel
                      carousel.addEventListener('pointerdown', function(event) {
                          outerFlickity.unbindDrag(); // Disable dragging for the outer Flickity slider
                      });
  
                      // Re-enable dragging on the outer slider when interaction ends
                      carousel.addEventListener('pointerup', function(event) {
                          outerFlickity.bindDrag(); // Re-enable dragging for the outer Flickity slider
                      });
  
                      // Also re-enable dragging when the pointer leaves the inner slider
                      carousel.addEventListener('pointerleave', function(event) {
                          outerFlickity.bindDrag();
                      });
                  });
              }
          }
      });
  }
});

function normalizeNumber(num, threshold = 2) {
  return Math.round(num / threshold) * threshold;
}


// Function to equalize heights of product titles per row
function equalizeProductTitleHeights() {
  const gridCells = document.querySelectorAll('.Grid__Cell:not(.Grid__Cell--Equalised)');
  let currentRowTop = null;
  let titleElements = [];
  let fullTileAspectElements = [];
  let tallestTitleHeight = 0;
  let tallestCellHeight = 0;

  function normalizeNumber(num, roundTo) {
    return Math.round(num / roundTo) * roundTo;
  }

  function applyHeights() {
    // 1. Equalize titles
    titleElements.forEach(el => el.style.height = `${tallestTitleHeight}px`);

    // 2. Set .AspectRatio height in .FullTile
    fullTileAspectElements.forEach(aspect => {
      aspect.style.height = `${tallestCellHeight}px`;
      aspect.style.paddingBottom = '0';
    });
  }

  gridCells.forEach((cell) => {
    const cellTop = normalizeNumber(cell.getBoundingClientRect().top, 10);
    const isNewRow = currentRowTop !== null && cellTop !== currentRowTop;

    if (isNewRow) {
      applyHeights(); // Apply for previous row
      // Reset row state
      titleElements = [];
      fullTileAspectElements = [];
      tallestTitleHeight = 0;
      tallestCellHeight = 0;
    }

    currentRowTop = cellTop;

    // Track tallest full grid item
    tallestCellHeight = Math.max(tallestCellHeight, cell.offsetHeight);

    // Track tallest title
    const title = cell.querySelector('.ProductItem__Title');
    if (title) {
      titleElements.push(title);
      tallestTitleHeight = Math.max(tallestTitleHeight, title.offsetHeight);
    }

    // Track .AspectRatio if this is a full tile
    if (cell.classList.contains('Grid__Cell--FullTile')) {
      const aspect = cell.querySelector('.ProductItem__ImageWrapper .AspectRatio');
      if (aspect) fullTileAspectElements.push(aspect);
    }

    cell.classList.add('Grid__Cell--Equalised');
  });

  // Final row
  applyHeights();
}

// Run on DOM ready and resize
document.addEventListener('DOMContentLoaded', () => {
  equalizeProductTitleHeights();

  window.addEventListener('resize', () => {
    document.querySelectorAll('.Grid__Cell--Equalised').forEach(cell =>
      cell.classList.remove('Grid__Cell--Equalised')
    );
    equalizeProductTitleHeights();
  });
});





/*This was initially developed to emualte the hover over to show the arrows, but I was asked to remove it*/
if(false){
  window.addEventListener('load', () => {
    // Function to add the hover-like effect when the element is fully visible
    function addHoverEffectOnce(entries, observer) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Add the hover-like class
          entry.target.classList.add('hover-simulated');
          
          // Remove the class after 2 seconds
          setTimeout(() => {
            entry.target.classList.remove('hover-simulated');
          }, 1000); 
    
          // Stop observing to avoid repeated triggers
          observer.unobserve(entry.target);
        }
      });
    }
    
    // Create an IntersectionObserver instance
    const observer = new IntersectionObserver(addHoverEffectOnce, {
      threshold: 1.0 // Trigger when the element is fully visible
    });
    
    // Select the elements to observe
    const elements = document.querySelectorAll('.ProductItem__ImageCarousel');
    elements.forEach(element => observer.observe(element));
  });
}

document.addEventListener('DOMContentLoaded', () => {
  let hasAnimated = false; // Flag to track if the animation has already occurred

  // Function to trigger slide action when the element is fully visible
  function triggerSliderOnce(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting && !hasAnimated) {
        // Perform the slide back-and-forth action
        var sliderElem = entry.target;
        var flkty = Flickity.data(sliderElem);

        if (flkty) {
          function slideBackAndForth() {
            // Slide to the second slide
            flkty.select(1);
            // Slide back to the first slide after a delay
            setTimeout(() => {
              flkty.select(0);
            }, 700); // Delay before sliding back
          }
          slideBackAndForth();
          hasAnimated = true; // Set the flag to true after the animation
        }

        // Stop observing to avoid repeated triggers
        observer.unobserve(entry.target);
      }
    });
  }

  // Function to observe the element and trigger the slider if width is <= 640px
  function observeSlider() {
    const element = document.querySelector('.ProductItem__ImageCarousel');

    if(!element) return;
    if (window.innerWidth <= 650) {
      const observer = new IntersectionObserver(triggerSliderOnce, {
        threshold: 1.0 // Trigger when the element is fully visible
      });

      observer.observe(element);
    }
  }

  // Initial check on load
  observeSlider();

  // Listen for window resize events
  window.addEventListener('resize', () => {
    // Re-check the screen width on resize and observe if <= 640px
    observeSlider();
  });
});

/* Add %OFF to upsell popup */
const observer = new MutationObserver((mutationsList, observer) => {
  for (const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      const upsellPopup = document.querySelector('lb-upsell-addon-popup.hydrated');
      if (upsellPopup) {
        const priceWraps = upsellPopup.querySelectorAll('.lb-spc-details-price-wrap');

        priceWraps.forEach(wrap => {
          const originalPriceEl = wrap.querySelector('.lb-spc-details-cmp-price');
          const discountedPriceEl = wrap.querySelector('.lb-spc-details-price');

          // Skip if any of the elements are missing
          if (!originalPriceEl || !discountedPriceEl) return;

          const originalPriceText = originalPriceEl.textContent.trim();
          const discountedPriceText = discountedPriceEl.textContent.trim();

          if (originalPriceText && discountedPriceText) {
            const parsePrice = str => parseFloat(str.replace(/[^0-9.]/g, ''));

            const originalPrice = parsePrice(originalPriceText);
            const discountedPrice = parsePrice(discountedPriceText);

            if (originalPrice > discountedPrice) {
              const discountPercent = Math.floor(((originalPrice - discountedPrice) / originalPrice) * 100);

              // Prevent duplicate labels
              if (!wrap.querySelector('.custom-discount-label')) {
                const label = document.createElement('span');
                label.className = 'custom-discount-label';
                label.textContent = `${discountPercent}% OFF`;
                label.style.cssText = `
                  display: inline-block;
                  background-color: #f5f5f5;
                  color: black;
                  padding: 0.2em 0.5em;
                  font-size: 0.875rem;
                  margin-left: 0.5em;
                `;

                originalPriceEl.insertAdjacentElement('afterend', label);
              }
            }
          }
        });
      }
    }
  }
});

observer.observe(document.body, { childList: true, subtree: true });

const params = new URLSearchParams(window.location.search);
if (params.get('cart') === 'open') {
  const interval = setInterval(() => {
    if (typeof window.SLIDECART_OPEN === 'function') {
      window.SLIDECART_OPEN();
      clearInterval(interval);
    }
  }, 250);

  // Stop after 10 seconds
  setTimeout(() => clearInterval(interval), 10000);
}


document.addEventListener('DOMContentLoaded', function() {
  var modal = document.getElementById('customAddToCartModal');
  var closeButton = document.getElementById('modal-close');

  if (modal && closeButton) {
    closeButton.addEventListener('click', function() {
      console.log('Modal closed with X button ❌');
      modal.close();
    });
  }
});

function lazyLoadVideos() {
  const videos = document.querySelectorAll('video.lazy-video');
  if (!videos.length) return;

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const video = entry.target;
        const wrapper = video.closest('.VideoWrapper');
        const poster = wrapper?.querySelector('.custom-poster');

        if (!video.querySelector('source')) {
          const source = document.createElement('source');
          source.src = video.dataset.src;
          source.type = 'video/mp4';
          video.appendChild(source);
          video.load();

          setTimeout(() => {
            video.play().catch(() => {});
          }, 100);
        }

        video.addEventListener('playing', () => {
          if (poster) poster.style.display = 'none';
        });

        obs.unobserve(video);
      }
    });
  }, {
    root: null,                // Use the viewport
    rootMargin: '0px',
    threshold: 0.6             // Trigger when at least 60% of the video is visible
  });

  videos.forEach(video => observer.observe(video));
}

document.addEventListener('DOMContentLoaded', () => {
  console.log(`[${performance.now().toFixed(2)}ms] DOMContentLoaded`);
  lazyLoadVideos();
});

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".CollectionTopFadeLink").forEach(link => {
    link.addEventListener("click", () => {
      if (typeof gtag === "function") {
        gtag("event", "collection_button_click", {
          button_text: link.dataset.buttonText,
          destination: link.href,
          page_location: window.location.href
        });
        //console.log("✅ Sent GA4 event:", link.dataset.buttonText);
      } else {
        //console.warn("⚠️ gtag not found, GA4 event not sent");
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const inputs = document.querySelectorAll(".CollectionTopFilter__Checkbox");

  if (!inputs.length) return;

  inputs.forEach(input => {
    input.addEventListener("change", () => {
      if (typeof gtag !== "function") return;

      gtag("event", "collection_colour_group_click", {
        filter_group: "colour_group",
        filter_value: input.value || "(unknown)",
        state: input.checked ? "selected" : "deselected",
        page_location: window.location.href
      });
    });
  });
});


document.addEventListener("DOMContentLoaded", () => {
  const sortButtons = document.querySelectorAll(".Linklist--sort .Popover__Value");

  sortButtons.forEach(button => {
    button.addEventListener("click", e => {
      e.preventDefault();
      const sortBy = button.dataset.value;

      // update URL params like the theme normally does
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set("sort_by", sortBy);
      currentUrl.searchParams.delete("page");

      // reload with sorted products
      if (window.theme && typeof window.theme.collection === "object" && typeof window.theme.collection._sortByChanged === "function") {
        // If you still have access to the Prestige collection object
        window.theme.collection._sortByChanged(sortBy);
      } else {
        // Fallback: reload directly
        window.location.href = currentUrl.toString();
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector(".CollectionTopFadeWrapper");
  if(!wrapper) return;
  const track = wrapper.querySelector(".CollectionTopFadeTrack");

  function updateFade() {
    const scrollLeft = track.scrollLeft;
    const maxScroll = track.scrollWidth - track.clientWidth;

    // toggle left fade
    if (scrollLeft > 0) {
      wrapper.classList.add("has-left-fade");
    } else {
      wrapper.classList.remove("has-left-fade");
    }

    // toggle right fade
    if (scrollLeft < maxScroll - 1) {
      wrapper.classList.add("has-right-fade");
    } else {
      wrapper.classList.remove("has-right-fade");
    }
  }

  // run on load + when scrolling
  updateFade();
  track.addEventListener("scroll", updateFade);
  window.addEventListener("resize", updateFade);
});


/* Open the modal popup after ATC but before Slidecart */
/*
document.addEventListener('DOMContentLoaded', function() {
  console.log('Custom ATC button click interception loaded ✅');

  var modal = document.getElementById('customAddToCartModal');

  document.querySelectorAll('form[action="/cart/add"] button[type="submit"]').forEach(function(button) {
    button.addEventListener('click', function(event) {
      console.log('✅ ATC button clicked:', button);

      event.preventDefault();  // Stop default click → stops SlideCart from running its form handler yet

      var form = button.closest('form');
      var formData = new FormData(form);
      var selectedVariantId = parseInt(formData.get('id'));

      console.log('Selected Variant ID:', selectedVariantId);

      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          console.log('Cart fetched ✅', cart);

          // Optional: Get the product_id for the selected variant
          fetch('/variants/' + selectedVariantId + '.js')
            .then(response => response.json())
            .then(function(variantData) {
              var selectedProductId = variantData.product_id;

              var duplicateVariantExists = cart.items.some(function(item) {
                return item.product_id === selectedProductId && item.variant_id !== selectedVariantId;
              });

              if (duplicateVariantExists) {
                console.log('Duplicate variant found ✅ Showing modal');

                if (modal) {
                  modal.showModal();

                  document.getElementById('modal-add-to-cart').onclick = function() {
                    console.log('User confirmed Add Anyway ✅');
                    modal.close();
                    form.submit();  // Now submit the form, triggering SlideCart's flow
                  };

                  document.getElementById('modal-find-size').onclick = function() {
                    console.log('User chose Find Size ✅');
                    modal.close();
                    window.location.href = '/pages/size-finder';
                  };
                } else {
                  console.warn('Modal not found ❌ Submitting form anyway');
                  form.submit();
                }
              } else {
                console.log('No duplicate variant ✅ Submitting form immediately');
                form.submit();
              }
            });
        });
    });
  });
});
*/
